import { render, staticRenderFns } from "./deliveryagentmaster_mr.vue?vue&type=template&id=0e5c321c&scoped=true&"
import script from "./deliveryagentmaster_mr.vue?vue&type=script&lang=js&"
export * from "./deliveryagentmaster_mr.vue?vue&type=script&lang=js&"
import style0 from "./deliveryagentmaster_mr.vue?vue&type=style&index=0&id=0e5c321c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c321c",
  null
  
)

export default component.exports